module.exports = {
          srcSet: __webpack_public_path__ + "a647ad8744b7129d2ee0c6c6ec838738-801.png"+" 801w",
          images:[ {path: __webpack_public_path__ + "a647ad8744b7129d2ee0c6c6ec838738-801.png",width: 801,height: 566}],
          src: __webpack_public_path__ + "a647ad8744b7129d2ee0c6c6ec838738-801.png",
          toString:function(){return __webpack_public_path__ + "a647ad8744b7129d2ee0c6c6ec838738-801.png"},
          
          width: 801,
          height: 566
        }